import { useQuery } from '@tanstack/react-query'
import { planningStatuses } from '@opallabs/api/v3'
import { OpalApiResponseDocument } from '../../../schema'
import { globalQueryKeys } from '../../queryKeys'

type ReadPlanningStatusesResponse = OpalApiResponseDocument<
  'ReadPlanningStatusesV3',
  200
>

/**
 * The planning statuses of the Opal. They are the same for every workspace, so
 * the key carries no workspace.
 */
export const useReadPlanningStatuses = <T = ReadPlanningStatusesResponse>({
  enabled,
  select,
}: {
  /** Set false to hold the fetch back until the list is wanted. */
  enabled?: boolean
  select?: (data: ReadPlanningStatusesResponse) => T
} = {}) =>
  useQuery({
    enabled,
    queryKey: globalQueryKeys.planningStatuses(),
    queryFn: () => planningStatuses.readCollection(),
    select,
  })
